import { BaseConfig } from "../config.interface";
import { Validate } from "../util";

interface IColorPickerConfig {
    label?: string;
    size?: "popup" | "inline";
    format?: "rgb" | "hex" | "hsb";
    validate: Validate;
}

export class ColorPickerConfig extends BaseConfig<IColorPickerConfig> implements IColorPickerConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Display the color-picker inline or with a popup-button
     * @values "popup" | "inline"
     */
    size?: "popup" | "inline";
    /**
     * Format of the result.
     * @values "rgb" | "hex" | "hsb" 
     */
    format?: "rgb" | "hex" | "hsb";
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base theme.
     */
    static baseTheme = {
        /**
         * Default configuration. Displays colorpicker inline (as a big element)
         * Format is "hex" by default.
         */
        Default: new ColorPickerConfig({
            size:     "inline",
            format:   "hex",
            validate: "dirty",
        }),
        /**
         * Smaller input with button to open popup.
         * Format is "hex" by default.
         */
        Popup: new ColorPickerConfig({
            validate: "dirty",
            size:     "popup",
            format:   "hex",
        })
    };
}
